import { useState } from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import BCModal from "../../ui/BCModal";

const LmsAccountingACHPaidMainPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loanDrawId,setLoanDrawId] = useState("");
  const [payeeOrganizationId,setPayeeOrganizationId] = useState("");
  const handleVendorClick = (rowData)=> {
    setIsModalOpen(true);
    setLoanDrawId(rowData.clickedRow.loanDrawId);
    setPayeeOrganizationId(rowData.clickedRow.payeeOrganizationId);
  };

  return (
    <>
      <BCModal
        closeIcon
        isModalOpen={isModalOpen}
        onClose={(): void => setIsModalOpen(false)}
        content={<AchPaidHistory loanDraw = {loanDrawId} payeeOrganization = {payeeOrganizationId} />}
        size="fullscreen"
      />
      <LmsTable
        apiSuffix="accounting/ach-paids"
        actionButtons={["export"]}
        handleClick={handleVendorClick}
      />
    </>
  );
};

const AchPaidHistory = ({ loanDraw, payeeOrganization }) => {
  return <LmsTable apiSuffix= {`accounting/ach/${loanDraw}/${payeeOrganization}`} actionButtons={["export"]} skipClick />;
};

const LmsAccountingACHPaid = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return <LmsAccountingACHPaidMainPage />;
};

export default LmsAccountingACHPaid;